import { Supplier, SupplierITA } from 'services/api/entities/crm/suppliers'
import { YupSchema, yupString } from 'services/yup'
import { SuppliedProduct } from 'types/common'
import { customerITAVS, customerVS } from './customer'

const commonValidations = {
  category: yupString<SuppliedProduct>().required(),
}

export const supplierVS: YupSchema<Supplier> = customerVS.shape({
  ...commonValidations,
})

export const supplierITAVS: YupSchema<SupplierITA> = customerITAVS.shape({
  ...commonValidations,
})
